<template>
  <div id="accountSecurity">
    <!-- Logo -->
    <el-row
      type="flex"
      class="logoWrap"
      :class="`${$mq}Mode`"
    >
      <el-col
        class="logoCol"
        :span="responsiveCol.one"
      >
        <div
          class="logo"
          @click="$router.push({name: 'login'}).catch((err) => {})"
        >
          <img
            src="@/assets/logo/gcg_logo.png"
            alt="logo"
          />
        </div>
      </el-col>

      <el-col
        v-if="$mq !== 'mobile'"
        class="sloganCol"
        :span="responsiveCol.one"
      >
        <div class="slogan">
          <img
            src="@/assets/logo/gcg_slogan.png"
            alt="logo"
          />
        </div>
      </el-col>
    </el-row>
    <!-- /Logo -->

    <!-- Security Card -->
    <div class="wrapper">
      <el-card
        :style="{width: dialogWidth}"
        shadow="hover"
      >
        <!-- default -->
        <div v-if="status === 'main'">
          <div class="title">
            {{ $t('account.newLoginDetected.title') }}
          </div>

          <div class="description">
            {{ $t('account.newLoginDetected.description') }}
          </div>

          <hr />

          <el-row
            class="descRow"
            :class="['mobile', 'tablet'].includes($mq) ? 'mobileMode' : 'deskMode'"
          >
            <el-col
              :span="responsiveCol.two"
              class="descCol"
            >
              <div class="descTitle">
                {{ $t('account.newLoginDetected.device') }}:
              </div>
              <div class="descData titleData">
                {{ log_data.device }}
              </div>
            </el-col>
            <el-col
              :span="responsiveCol.two"
              class="descCol"
            >
              <div class="descTitle">
                {{ $t('account.newLoginDetected.ipAddress') }}:
              </div>
              <div class="descData titleData">
                {{ log_data.ip }}
              </div>
            </el-col>
          </el-row>

          <el-row
            class="descRow"
            :class="['mobile', 'tablet'].includes($mq) ? 'mobileMode' : 'deskMode'"
          >
            <el-col
              :span="responsiveCol.two"
              class="descCol"
            >
              <i class="descIcon el-icon-time"></i>
              <div class="descData">
                {{ log_data.time }}
              </div>
            </el-col>
            <el-col
              :span="responsiveCol.two"
              class="descCol"
            >
              <i class="descIcon el-icon-location-outline"></i>
              <div class="descData">
                {{ log_data.city }}, {{ log_data.country }}
              </div>
            </el-col>
          </el-row>

          <hr />

          <div class="ask">
            {{ $t('account.newLoginDetected.ask') }}
          </div>

          <div class="actions">
            <el-row>
              <el-col :span="responsiveCol.button">
                <el-button
                  type="default"
                  @click="answer(false)"
                >
                  <i class="buttonIcon redIcon el-icon-close"></i>
                  <div class="buttonText">
                    {{ $t('account.newLoginDetected.answerNo') }}
                  </div>
                </el-button>
              </el-col>
              <el-col :span="responsiveCol.button">
                <el-button
                  type="default"
                  @click="answer(true)"
                >
                  <i class="buttonIcon greenIcon el-icon-check"></i>
                  <div class="buttonText">
                    {{ $t('account.newLoginDetected.answerYes') }}
                  </div>
                </el-button>
              </el-col>
            </el-row>
          </div>
        </div>
        <!-- default -->

        <!-- pass -->
        <div v-if="status === 'pass'">
          <div class="title">
            {{ $t('account.resetPw') }}
          </div>

          <el-form
            ref="passwordForm"
            :model="passwordForm"
            :rules="rules"
            @keyup.enter="submit"
          >
            <el-form-item
              :label="$t('account.newPw')"
              prop="password"
              :error="error.password[0]"
            >
              <el-input
                v-model="passwordForm.password"
                autocomplete="off"
                show-password
              />
            </el-form-item>

            <el-form-item
              :label="$t('account.newPwConfirm')"
              prop="passwordConfirmation"
            >
              <el-input
                v-model="passwordForm.passwordConfirmation"
                autocomplete="off"
                show-password
              />
            </el-form-item>
          </el-form>

          <div class="actions">
            <el-button
              type="primary"
              round
              @click="submit"
            >
              {{ $t('common.submit') }}
            </el-button>
          </div>
        </div>
        <!-- /pass -->

        <!-- status -->
        <div v-if="['done', 'passdone', 'error'].includes(status)">
          <div class="title">
            {{ $t(`account.newLoginDetected.result.${status}.title`) }}
          </div>

          <div class="description">
            {{ $t(`account.newLoginDetected.result.${status}.description`) }}
          </div>
        </div>
        <!-- /status -->
      </el-card>
    </div>
  </div>
</template>

<script>
import api from '@/api';
import DialogSetting from '@/mixins/dialog';

export default {
  mixins: [DialogSetting],

  data() {
    return {
      status: 'main',
      log_data: {
        device: '',
        time: '',
        ip: '',
        country: '',
        city: '',
      },
      passwordForm: {
        password: '',
        passwordConfirmation: '',
      },
      rules: {
        password: [
          { required: true, message: `${this.$t('common.rule.password.requiredNew')}`, trigger: 'blur' },
          {
            min: 8, message: `${this.$t('common.rule.password.pwMinChar8')}`, trigger: 'blur',
          },
        ],
        passwordConfirmation: [
          {
            required: true,
            message: `${this.$t('common.rule.password.requiredConfirm')}`,
            trigger: 'blur',
          },
          { validator: this.checkPasswordConfirmation, trigger: 'blur' },
        ],
      },
      error: {
        password: [],
      },
    };
  },

  computed: {
    responsiveCol() {
      const col = {};
      if (this.$mq === 'mobile') {
        col.one = 24;
        col.two = 24;
        col.button = 24;
      } else if (this.$mq === 'tablet') {
        col.one = 12;
        col.two = 24;
        col.button = 24;
      } else {
        col.one = 12;
        col.two = 24;
        col.button = 12;
      }
      return col;
    },
  },

  mounted() {
    this.log_data = this.$route.query;
    // console.log(this.$route.params);
  },

  methods: {
    async answer(command) {
      if (command === false) {
        this.status = 'pass';
      } else {
        try {
          await this.allowIP();
          this.status = 'done';
        } catch (err) {
          console.log(err);
        }
      }
    },

    checkPassword(rule, value, callback) {
      // check if it s numeric
      if (!Number.isNaN(Number(value))) {
        callback(new Error(this.$t('common.rule.password.pwNotNumeric')));
      } else {
        callback();
      }
    },

    checkPasswordConfirmation(rule, value, callback) {
      if (value !== this.passwordForm.password) {
        callback(new Error(this.$t('common.rule.password.pwUnmatched')));
      } else {
        callback();
      }
    },

    async allowIP() {
      try {
        const param = {
          uid64: this.$route.params.uid64,
          token: this.$route.params.token,
        };

        const response = await api.unknownAllowIP(param.uid64, param.token, {
          response: true,
          ip: this.log_data.ip,
        });

        if (response.status === 200) {
          this.status = 'done';
        } else {
          this.status = 'error';
        }
      } catch (err) {
        console.log('Error send new ip', err);
        this.status = 'error';
      }
    },

    async submit() {
      try {
        await this.$refs.passwordForm.validate();

        try {
          this.error.password = [];
          const param = {
            uid64: this.$route.params.uid64,
            token: this.$route.params.token,
          };

          const response = await api.unknownResetPassword(param.uid64, param.token, {
            response: false,
            new_password: this.passwordForm.password,
            ip: this.log_data.ip,
          });

          if (response.status === 200) {
            this.status = 'passdone';
          } else {
            this.status = 'error';
          }
        } catch (err) {
          if (err.response.data.password) {
            this.error.password = err.response.data.password;
          } else if (err.msg) {
            this.$message.error(err.msg);
            this.status = 'error';
          }
        }
      } catch (err) {
        console.log('Error new password submit', err);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  #accountSecurity {
    padding-bottom: 30px;

    hr {
      opacity: 0.6;
    }

    .logoWrap {
      width: 100%;
      padding: 45px 5% 10px;

      .logoCol {
        .logo {
          img {
            width: 110px;
          }
        }
      }

      .sloganCol {
        text-align: right;

        .slogan {
          img {
            width: 180px;
          }
        }
      }

      &.mobileMode {
        padding: 30px 0;

        .logoCol {
          text-align: center;

          .logo {
            img {
              width: 100px !important;
            }
          }
        }
      }

      &.tabletMode {
        padding: 40px 5%;

        .logoCol {
          .logo {
            img {
              width: 100px !important;
            }
          }
        }

        .sloganCol {
          .slogan {
            img {
              width: 170px !important;
            }
          }
        }
      }
    }

    .wrapper {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;

      .el-card {
        max-width: 1200px;
        border-radius: 10px;
        margin: 0 auto;

        .title {
          text-align: center;
          font-weight: 600;
          font-size: 26px;
          margin: 25px 0 15px;
        }

        .description {
          text-align: center;
          margin-bottom: 30px;
          font-size: 16px;
        }

        .descRow {
          display: inline-block;
          width: 50%;
          padding: 0 15px;
          vertical-align: middle;

          &.mobileMode {
            width: 100%;
          }

          .descCol {
            padding: 10px 5px;

            .descTitle {
              display: inline-block;
              font-weight: bold;
            }

            .descIcon {
              display: inline-block;
              vertical-align: middle;
              margin-right: 5px;

              &::before {
                font-size: 20px;
                color: rgba(0, 0, 0, 0.5);
              }
            }

            .descData {
              display: inline-block;
              width: calc(100% - 25px);
              vertical-align: middle;

              &.titleData {
                display: inline;
              }
            }
          }
        }

        .ask {
          text-align: center;
          margin: 45px 0 21px;
          font-size: 16px;
        }
      }
    }
  }
</style>

<style lang="scss">
  #accountSecurity {
    .wrapper {
      .el-card {
        .actions {
          text-align: center;
          padding-bottom: 20px;

          .el-col {
            padding: 5px 20px;

            .el-button {
              display: flex;
              width: 100%;
              justify-content: center;
              border-radius: 10px;
              border: 1px solid #c4c4c4;
              padding: 10px 15px;

              span {
                display: inline-block;
                width: 100%;
                text-align: center;
              }

              .buttonIcon {
                display: inline-block;
                width: 20px;
                vertical-align: middle;
                margin-right: 10px;

                &::before {
                  font-size: 23px;
                  font-weight: bold;
                }

                &.redIcon {
                  color: red;
                }

                &.greenIcon {
                  color: green;
                }
              }

              .buttonText {
                display: inline-block;
                width: calc(100% - 30px);
                white-space: normal;
                color: #000;
                vertical-align: middle;
                word-break: break-word;
              }
            }
          }
        }

        .el-form {
          margin-bottom: 30px;

          .el-input__inner {
            border-radius: 0;
            border-top: 0;
            border-left: 0;
            border-right: 0;
          }
        }
      }
    }
  }
</style>
